import axios from 'axios';
import { buildApiUrl } from '../config/api';

if (!axios.__PROFILE_AUTH_INTERCEPTOR_ATTACHED__) {
  axios.interceptors.request.use((config) => {
    try {
      const stored = localStorage.getItem('user');
      if (stored) {
        const parsed = JSON.parse(stored);
        const token = parsed?.access || parsed?.token;
        if (token) {
          config.headers = config.headers || {};
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('Failed to attach auth token', error);
    }
    return config;
  });

  Object.defineProperty(axios, '__PROFILE_AUTH_INTERCEPTOR_ATTACHED__', {
    value: true,
    writable: false,
  });
}

const resolveUserEndpoint = (userId) => {
  if (!userId) {
    throw new Error('User id is required to load or update the profile');
  }
  return buildApiUrl(`/users/${userId}/`);
};

const normaliseResponse = (payload) => {
  if (!payload) {
    return {};
  }
  if (Array.isArray(payload)) {
    return payload[0] || {};
  }
  if (payload.data) {
    return payload.data;
  }
  return payload;
};

const profileService = {
  async getProfile(userId) {
    const response = await axios.get(resolveUserEndpoint(userId));
    return normaliseResponse(response.data);
  },

  async updateProfileField(userId, field, value) {
    const payload = { [field]: value };
    const response = await axios.patch(resolveUserEndpoint(userId), payload);
    return normaliseResponse(response.data);
  },

  async updateProfile(userId, payload) {
    const response = await axios.patch(resolveUserEndpoint(userId), payload);
    return normaliseResponse(response.data);
  },

  async updateProfilePhoto(userId, file) {
    const formData = new FormData();
    formData.append('photo', file);

    const response = await axios.patch(resolveUserEndpoint(userId), formData);
    return normaliseResponse(response.data);
  },
};

export default profileService;
